/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function VideoPopupSlider(elem) {
        Behaviors.init(VideoPopupSlider, this, arguments);
        var $thisElem = this.$elem;

        $('.VideoPopupSlider-content_items_item_popup_link').fancybox({
            arrows: true,
            infobar: true,
            toolbar: true,
            Image: {
                zoom: false,
            },
            fullscreen: {
                autoStart: true,
            },
            buttons: [
                "slideShow",
                "fullScreen",
                "close"
            ],
        });

        var swiper = new Swiper(".VideoPopupSlider-content_items", {
            slidesPerView: 'auto',
            // slidesPerView: 6,
            initialSlide: 0,
            loop: false,
            speed: 800,
            autoplay: false,
            navigation: {
                nextEl: '.VideoPopupSlider-slider-nav .slick-next',
                prevEl: '.VideoPopupSlider-slider-nav .slick-prev'
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                dragSize: 158
            },
            freeMode: true,
            mousewheel: {
              releaseOnEdges: true,
              forceToAxis: true
            }
        });

    }
    Behaviors.inherit(VideoPopupSlider, Behaviors.Behavior);
    VideoPopupSlider.QUERY = "[data-VideoPopupSlider]";
    VideoPopupSlider.ELEMENTS = {
        elementClass: ".VideoPopupSlider-class",
    };
    Behaviors.register_behavior(VideoPopupSlider);
    module.VideoPopupSlider = VideoPopupSlider;
    return module;
}(window.jQuery, window.Behaviors));
